import AppPicture from './AppPicture.vue';

export default AppPicture;



// WEBPACK FOOTER //
// ./src/uikit/components/AppPicture/index.ts